import Put from '../services/Put';

import { nexcareVersion } from '../config/serviceConfig';

const putStatusOnline = (token) => Put(`/${nexcareVersion}/nexcare/user-cs/go-online`, null, token);
const putStatusOffline = (token) => Put(`/${nexcareVersion}/nexcare/user-cs/go-offline`, null, token);

const API_STATUS = {
    putStatusOnline,
    putStatusOffline
}

export default API_STATUS;